import { TechSkills } from "./all-skills-data";

// Skills Section Data
export const mySkills = [
  {
    scopeTitle: "Programming Languages",
    skills: [
      TechSkills.JavaScript,
      TechSkills.TypeScript,
      TechSkills.Python,
      TechSkills.CPlusPlus,
    ],
  },
  {
    scopeTitle: "Backend Development",
    skills: [
      TechSkills.NodeJS,
      TechSkills.ExpressJS,
      TechSkills.MongoDB,
      TechSkills.PostgreSQL,
      TechSkills.SQLite,
      TechSkills.Redis,
      TechSkills.GraphQL,
    ],
  },
  {
    scopeTitle: "Frontend Development",
    skills: [
      TechSkills.React,
      TechSkills.NextJS,
      TechSkills.ReactQuery,
      TechSkills.Redux,
      TechSkills.PugJS,
      TechSkills.HTML,
    ],
  },
  {
    scopeTitle: "Web Styling",
    skills: [TechSkills.CSS, TechSkills.TailwindCSS, TechSkills.Bootstrap],
  },
  {
    scopeTitle: "Tools & Cloud",
    skills: [
      TechSkills.Git,
      TechSkills.GitHub,
      TechSkills.Docker,
      TechSkills.Postman,
      TechSkills.VSCode,
      TechSkills.AWS,
    ],
  },
];
